import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { Threshold } from './threshold';
import { wilkinsonExtended } from '../tick-methods/wilkinson-extended';
import { d3LinearNice } from '../utils';
/**
 * 类似 Threshold 比例尺，区别在于 thresholds 是根据连续的 domain 根据离散的 range 的数量计算而得到的。
 */
export var Quantize = /*#__PURE__*/function (_Threshold) {
  _inherits(Quantize, _Threshold);
  _createClass(Quantize, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0.5],
        nice: false,
        tickCount: 5,
        tickMethod: wilkinsonExtended
      };
    }
  }]);
  function Quantize(options) {
    _classCallCheck(this, Quantize);
    return _possibleConstructorReturn(this, _getPrototypeOf(Quantize).call(this, options));
  }
  _createClass(Quantize, [{
    key: "nice",
    value: function nice() {
      var nice = this.options.nice;
      if (nice) {
        var _this$getTickMethodOp = this.getTickMethodOptions(),
          _this$getTickMethodOp2 = _slicedToArray(_this$getTickMethodOp, 3),
          min = _this$getTickMethodOp2[0],
          max = _this$getTickMethodOp2[1],
          tickCount = _this$getTickMethodOp2[2];
        this.options.domain = d3LinearNice(min, max, tickCount);
      }
    }
  }, {
    key: "getTicks",
    value: function getTicks() {
      var tickMethod = this.options.tickMethod;
      var _this$getTickMethodOp3 = this.getTickMethodOptions(),
        _this$getTickMethodOp4 = _slicedToArray(_this$getTickMethodOp3, 3),
        min = _this$getTickMethodOp4[0],
        max = _this$getTickMethodOp4[1],
        tickCount = _this$getTickMethodOp4[2];
      return tickMethod(min, max, tickCount);
    }
  }, {
    key: "getTickMethodOptions",
    value: function getTickMethodOptions() {
      var _this$options = this.options,
        domain = _this$options.domain,
        tickCount = _this$options.tickCount;
      var min = domain[0];
      var max = domain[domain.length - 1];
      return [min, max, tickCount];
    }
  }, {
    key: "rescale",
    value: function rescale() {
      this.nice();
      var _this$options2 = this.options,
        range = _this$options2.range,
        domain = _this$options2.domain;
      var _domain = _slicedToArray(domain, 2),
        x0 = _domain[0],
        x1 = _domain[1];
      this.n = range.length - 1;
      this.thresholds = new Array(this.n);
      for (var i = 0; i < this.n; i += 1) {
        this.thresholds[i] = ((i + 1) * x1 - (i - this.n) * x0) / (this.n + 1);
      }
    }
    /**
     * 如果是在第一段后或者最后一段就把两端的值添加上
     */
  }, {
    key: "invert",
    value: function invert(y) {
      var _superPropGet2 = _superPropGet(Quantize, "invert", this, 3)([y]),
        _superPropGet3 = _slicedToArray(_superPropGet2, 2),
        a = _superPropGet3[0],
        b = _superPropGet3[1];
      var _this$options$domain = _slicedToArray(this.options.domain, 2),
        x0 = _this$options$domain[0],
        x1 = _this$options$domain[1];
      return a === undefined && b === undefined ? [a, b] : [a || x0, b || x1];
    }
  }, {
    key: "getThresholds",
    value: function getThresholds() {
      return this.thresholds;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Quantize(this.options);
    }
  }]);
  return Quantize;
}(Threshold);